import styles from './react-shared-lib.module.scss';
import { LicenseManager } from 'ag-grid-enterprise';
import { LicenseInfo } from '@mui/x-license-pro';

// Mui X lisens
LicenseInfo.setLicenseKey(
  '28ca8909fd38b273d8b427fd1de5c580T1JERVI6NDM0MTYsRVhQSVJZPTE2ODM3OTI4NTYwMDAsS0VZVkVSU0lPTj0x',
);

// LicenseManager.setLicenseKey("CompanyName=Focus Software AS,LicensedGroup=Webkua,LicenseType=MultipleApplications,LicensedConcurrentDeveloperCount=1,LicensedProductionInstancesCount=0,AssetReference=AG-016455,ExpiryDate=15_June_2022_[v2]_MTY1NTI0NzYwMDAwMA==7e11babf315f2bbd8946bd70c6fccdea");
LicenseManager.setLicenseKey("CompanyName=Focus Software AS,LicensedGroup=Paal Eskerud,LicenseType=MultipleApplications,LicensedConcurrentDeveloperCount=2,LicensedProductionInstancesCount=1,AssetReference=AG-026538,ExpiryDate=22_March_2023_[v2]_MTY3OTQ0MzIwMDAwMA==7ef1996e1189b3f1acaf8eb47f4e68fa");

/* eslint-disable-next-line */
export interface ReactSharedLibProps { }

export function ReactSharedLib(props: ReactSharedLibProps) { }

export default ReactSharedLib;
